import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionAnimation = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "f5097b73-1152-4e95-8919-54eed014af82",
			"type": "page",
			"properties": {
				"title": [
					[
						"Анимации"
					]
				]
			},
			"content": [
				"b8cd142b-13cc-43a1-ba5c-99d70b1f1844",
				"b79c8732-9e88-438f-ab30-6e8b44724f3c",
				"d581e6ff-3d59-4aaf-ba09-f9be66e377ed",
				"a0b74711-2b99-46a6-860b-35c5261c47bd",
				"fbedfec5-78b5-492b-8c0e-4ea79b34d5b6",
				"7d3b0a63-db53-49d6-9c08-e64c535172cc",
				"7ebd3b5c-fdab-4ba1-aeb0-1675fb993184",
				"c6d67d3d-5875-4244-a949-1cc165f47fc7",
				"22b5ab48-f5b6-4651-b949-f87f50fb14bf",
				"19564bab-9758-4c71-a7a2-87ffb0226804",
				"72db9f91-6a1f-4827-bbfb-3392641b6573",
				"14f8595d-5caa-478a-af8a-1a75473a7e70",
				"cc0fb34b-23c4-4471-b863-200a10174b37",
				"c3fcb166-00f7-4101-accc-dd76fad20a62",
				"cc7a3d69-dfd6-4379-9e77-4d7c07171645",
				"69329b47-9c21-4f94-8230-24645448e5ad",
				"4cd781e7-a0e1-4a82-8a94-65f748112712",
				"3b5f674e-762d-4159-bf2d-11f03861c449",
				"42447068-43a6-4314-be28-4574b8102f64",
				"9342fb9f-ef40-4fc2-970f-f988f335b46a",
				"65db706d-3e41-48b3-a13f-eba27d4fe551",
				"4bf37917-5ff7-4253-818a-06d9995cc65e",
				"dbc98f5d-8703-4ef4-9399-e829d91ddf4f",
				"2e3d3468-beb3-4447-af37-27b43f78c5aa",
				"755430a7-f45d-4673-bd93-b6e81f3527db",
				"a2cd5d2e-e734-4cac-85b6-75cfdec256e4",
				"7b8dc5d6-d893-439e-8057-7550f87a5c72",
				"ad08bf64-2a74-4499-9dea-61d16e98096f",
				"40044b65-7e34-44a6-a826-dddedfc67143",
				"c245f145-8074-4120-9930-80e001fe41f9",
				"1772a882-1a3e-44c0-b8fd-f327ac628048",
				"d9bbd0d6-7872-44ce-9b4e-bf0599f130e4",
				"e3de68f7-fbab-49ba-be69-ac46a16a886d",
				"17f91730-911c-43ab-b319-cffb64eb1a62",
				"eed5821e-e73d-401e-90bf-aa33e67e26e6",
				"85e66f9a-fbb3-474d-8462-9706a1005f85",
				"bfa5997f-30a6-44c0-9c80-eeb71b7b15e2",
				"9fb57c41-f450-42cc-8771-0330e4bfd4f1",
				"db789f39-1839-480b-aa5d-ece982b984fa",
				"07383570-3b58-46d3-ad35-6eaa2d84bfde",
				"c20edb91-035d-4f38-92bf-4ced286c093b",
				"e21b7636-43e7-4d88-8998-cc66d2f44571",
				"3d9221c1-3a4f-49f7-9bce-a03a33408875",
				"49de594a-5707-4e5f-a1b2-83bb43fad7c3",
				"3bf72109-c52c-433a-bcdc-a423c3f6e437",
				"856b238f-9d1e-44b9-9917-6b4bf5c2ccc2",
				"d4eac6b9-ac8c-4dd2-bd52-39b89ce9ced6",
				"ba430382-6fde-48af-8bf9-a37165561709",
				"ab94efa7-8dc1-48ad-8ba8-5ea69ece95c4",
				"99c48cbd-d0e9-4bec-830f-354373366887",
				"7a88d48e-5888-488d-a69e-f8910b8b81a1",
				"ecbc137f-5799-47f5-8279-3ec38e745bda",
				"6e6b2571-e5bb-4a3a-82fd-465f650ac471",
				"94332ab1-60db-428b-ade2-a14c256f2507",
				"ff9c4b0f-b694-4cba-b64b-cc45339a030a",
				"50de8974-41f5-4e7e-a8e1-3b8047f75ba4",
				"5c9741a6-cd34-4ec2-8e82-1f74cf509fae",
				"32acf4a1-9593-4c81-8ed5-a30e802ab2f3",
				"97b2e2cb-8638-4d67-bfe8-101c8b86c35c",
				"f259af99-39d0-4dc9-a720-c8a8a6254cb5",
				"f1858551-ebc4-4d66-999a-446ccdf09aca",
				"765d410d-b04b-4c31-ae79-294535b6ba1a",
				"d4f9c59a-31c4-4780-9d52-4b5fa59f082f",
				"36593fa5-d28f-4c2f-8167-c9173cc11712",
				"5bdf0fd7-9471-4d47-99d5-7046a90534e9",
				"56320cca-8dfb-4dcb-8e5d-ad755313ccbe",
				"b5c068ca-ab00-4f85-81b5-852ee5b16412",
				"cc5e04fc-49ad-42f9-b2f0-309bfdefafc8",
				"473262a3-8620-45ce-a0f7-83b5d1207b9e",
				"0f75ba3d-1ec8-4f2b-9be1-84852460671b",
				"af9f153b-4718-44ea-aaef-6ddf7465dd58",
				"a75f600e-71d9-4fa8-bb5c-042dec9f8596",
				"5ec55e84-611e-49ef-b7dd-7c7c8a921675",
				"431140f6-55dd-45a5-85b9-ad9a597a460e",
				"4bc66b77-a717-4a7c-8d3e-f61271020c53",
				"7cda7cea-45eb-4121-87ea-70ffcbca4f69",
				"6dee9413-b646-4268-a6f1-836a8dee18e6",
				"dc1e8088-4784-46bd-91d8-db9ba0b46fff",
				"fa87742d-6087-42bb-84f1-fc359a187294",
				"e60e48eb-b09b-4a8b-b9b0-77df41871ed0",
				"ecde79fa-f8c8-48e4-afe8-43882bbd17c6",
				"a87c750d-a0d8-4ae1-bb4a-d826bbdb3d5c",
				"3d6a0bfb-278a-4b30-9bb5-845999a19f41",
				"abb63b77-b634-4fff-8041-e600e8ff0c27",
				"5706acae-d769-494a-85bd-085dedafc769",
				"be1c6c9a-e3e3-416b-bfe1-45d754e36513",
				"16dc49fb-fda7-42d3-95a7-4a09b9cdfd75",
				"7776dcea-80be-47f1-9916-bdd2010de9a7",
				"2bd03e65-19c2-472b-9dab-45a87e89b87b",
				"44ca9810-59a7-49a2-8f0a-a1ff51b810ac",
				"10041b9d-1105-4d27-bf29-945afd3aaac6",
				"10d234bc-f4d7-4a51-aa39-48eb48ddf6c6",
				"c4f31633-8e5b-400d-97b9-600bfc4176db",
				"02df4192-bdff-444b-9543-69dcc30be3b8",
				"0f6b011f-add7-472c-ba5c-56a3b6ee356f",
				"2aa96f2c-ed57-4ef9-ad94-29f6eac6efa1",
				"498b80ee-29bf-4f5c-a1bf-fb993170f5b8",
				"959484b9-20f8-4e0a-b58e-f0a6df6e7e2b",
				"5f5d2e91-3fc1-45b7-baeb-c8c048957503",
				"2021ec11-aa3a-4dce-8e1d-c3be03bbb5bf",
				"2b1930a1-8466-459c-aed9-7419e87cc7ef",
				"f776aaed-5f16-462a-8346-37c4c9a50d59",
				"ab3eeaa6-1d58-449d-8f70-6a27f746e4d5",
				"959970cd-852e-40e6-aabb-4a63f4a200f4",
				"93f8b320-b1ca-4c5b-b239-647e4dc53e35",
				"7d829e6b-03da-4281-9ea2-e60bee3d6612",
				"3640bc3b-cc4a-4d24-b161-364cb605cac3",
				"11d15091-54fd-410a-9580-4d6a85cd8d0a",
				"635e1327-92fa-4a3f-b5bb-1fe0eaaf33f4",
				"521a86af-a746-49f5-91eb-a22548f51225",
				"46f1130b-b880-40a7-a916-115ed4a98d28",
				"9f1c5df7-7f6e-4d0c-9f6c-0d3685b70622",
				"3237c494-50bd-45e1-b0c9-d18166a76522",
				"77839ceb-b770-4d96-b22c-aceac4af56e6",
				"4e18e4b2-047f-48ad-9d43-f8e27250b510",
				"e654da12-5cdb-48ba-8207-2f67c1f99e24",
				"ae9026cb-4738-427a-95ef-32a44dd65f39",
				"9327abbe-3b6a-4617-a56b-6c2a7c10533e",
				"b93d5497-0e22-4919-97ec-d4db61c7277d",
				"42a9f433-cfdb-4742-a14c-30bbcb013b04",
				"359523b4-3960-43d5-9ccc-8f2bd0d75f82",
				"7630b6d8-8f5d-4dde-921f-be11d8f10f37",
				"e6f212a6-0a8d-49f9-95c2-b4bd9da5ad63",
				"fb6875e3-899a-4d44-ae85-aef12f2554f6"
			],
			"format": {
				"copied_from_pointer": {
					"id": "a7ebc923-836d-474c-b445-d1d279a9eda1",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"file_ids": [
				"32b9559c-ceca-4728-82c4-6f064c8a6d38"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b8cd142b-13cc-43a1-ba5c-99d70b1f1844",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/animation\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5ec5be76-efc5-432d-9606-c0f77b247c89",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b79c8732-9e88-438f-ab30-6e8b44724f3c",
			"type": "text",
			"properties": {
				"title": [
					[
						"Анимации — важная часть визуального языка продукта, поэтому мы уделяем им много времени. Важно, чтобы анимации выполняли задачи и эффектно выглядели."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "531906c4-c9cd-4681-8384-716bf7b280d9",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d581e6ff-3d59-4aaf-ba09-f9be66e377ed",
			"type": "header",
			"properties": {
				"title": [
					[
						"Задачи"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "664d3395-49e3-432c-8d17-6bb5334aa5d5",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a0b74711-2b99-46a6-860b-35c5261c47bd",
			"type": "text",
			"properties": {
				"title": [
					[
						"Дизайнер использует анимацию для решения определённой задачи, даже если это создание вау-эффекта. Важно определиться с тем, какую задачу решает анимация."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "c5e628ca-5e5d-4b98-b9d1-3c4ce87a0d53",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fbedfec5-78b5-492b-8c0e-4ea79b34d5b6",
			"type": "text",
			"properties": {
				"title": [
					[
						"Анимация плохая, если:"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "2e430471-43b6-4d7a-9d49-6a66e9c43e28",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7d3b0a63-db53-49d6-9c08-e64c535172cc",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"сложно объяснить её необходимость;"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "7cabb327-f544-412f-8d2e-1ccad840a8fa",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7ebd3b5c-fdab-4ba1-aeb0-1675fb993184",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"она мешает пользоваться интерфейсом;"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "7440c9f5-41d7-4f5a-9c12-d781b5c750f2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c6d67d3d-5875-4244-a949-1cc165f47fc7",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"она заставляет ждать там, где не нужно."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "58e43c68-d7b3-48ed-90e6-54c14a8db7ca",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "22b5ab48-f5b6-4651-b949-f87f50fb14bf",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Обратная связь"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "bfe331aa-7c0b-4345-8a66-a85f9d00da47",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "19564bab-9758-4c71-a7a2-87ffb0226804",
			"type": "text",
			"properties": {
				"title": [
					[
						"Хороший интерфейс понятен пользователю, поэтому любое действие пользователя должно иметь визуальный фидбэк."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "72abf028-299c-44c7-9054-95e550373f32",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "72db9f91-6a1f-4827-bbfb-3392641b6573",
			"type": "video",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/6ba14b6f-ef7d-4931-a861-4efd069564af/main.mp4"
					]
				]
			},
			"format": {
				"block_width": 624,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/6ba14b6f-ef7d-4931-a861-4efd069564af/main.mp4",
				"block_full_width": false,
				"block_page_width": true,
				"copied_from_pointer": {
					"id": "1cb9606c-1939-4d73-9977-bd10fc4e370a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": false
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"6ba14b6f-ef7d-4931-a861-4efd069564af"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/72db9f91-6a1f-4827-bbfb-3392641b6573.mp4"
		},
		{
			"id": "14f8595d-5caa-478a-af8a-1a75473a7e70",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "aaaf71ca-00cd-4806-ac15-56cf972148dd",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cc0fb34b-23c4-4471-b863-200a10174b37",
			"type": "text",
			"properties": {
				"title": [
					[
						"В веб-версиях наших сервисов предусмотрен фидбэк при наведении курсора."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "18abd007-5bc6-4c62-aa66-0d3c7ae98fc8",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c3fcb166-00f7-4101-accc-dd76fad20a62",
			"type": "video",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/63e34f66-c9ca-4ea6-aef8-fae695cfeb6e/main.mp4"
					]
				]
			},
			"format": {
				"block_width": 672,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/63e34f66-c9ca-4ea6-aef8-fae695cfeb6e/main.mp4",
				"block_full_width": false,
				"block_page_width": true,
				"copied_from_pointer": {
					"id": "38a3516b-5313-43c1-ab61-d9a57861618c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": false
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"63e34f66-c9ca-4ea6-aef8-fae695cfeb6e"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/c3fcb166-00f7-4101-accc-dd76fad20a62.mp4"
		},
		{
			"id": "cc7a3d69-dfd6-4379-9e77-4d7c07171645",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Статус"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e4c3d9c0-af46-44b6-9e03-422e26d62557",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "69329b47-9c21-4f94-8230-24645448e5ad",
			"type": "text",
			"properties": {
				"title": [
					[
						"Анимации могут отображать статус действия пользователя."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "52fda304-9f4d-4017-9d92-b9520388b0e7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4cd781e7-a0e1-4a82-8a94-65f748112712",
			"type": "video",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a870c868-7449-40e9-82f4-db9c2fa38d32/main_1.mp4"
					]
				]
			},
			"format": {
				"block_width": 624,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a870c868-7449-40e9-82f4-db9c2fa38d32/main_1.mp4",
				"block_full_width": false,
				"block_page_width": true,
				"copied_from_pointer": {
					"id": "3782813f-ae61-44b4-b082-db2a53cfcdf0",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": false
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"a870c868-7449-40e9-82f4-db9c2fa38d32"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/4cd781e7-a0e1-4a82-8a94-65f748112712.mp4"
		},
		{
			"id": "3b5f674e-762d-4159-bf2d-11f03861c449",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "c76709a0-1e3e-4a64-90be-9127487e02b4",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "42447068-43a6-4314-be28-4574b8102f64",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Привлечение внимания"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "66fe0a53-54b5-475c-8132-4421253f3165",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9342fb9f-ef40-4fc2-970f-f988f335b46a",
			"type": "text",
			"properties": {
				"title": [
					[
						"Мозг прикладывает усилие, когда человек смотрит на движущийся объект. Поэтому анимация помогает сделать заметнее элементы, которые важны прямо сейчас. Например, анимация привлекает внимание пользователя к уведомлениям."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "cb40d9eb-c5a6-43c5-85a8-1e917e901e74",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "65db706d-3e41-48b3-a13f-eba27d4fe551",
			"type": "video",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/c9276a11-293c-459b-90d6-c33dfe3721b4/main.mp4"
					]
				]
			},
			"format": {
				"block_width": 576,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/c9276a11-293c-459b-90d6-c33dfe3721b4/main.mp4",
				"block_full_width": false,
				"block_page_width": true,
				"copied_from_pointer": {
					"id": "fe4974c6-1b4f-479b-b10c-b8832a4072cc",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": false
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"c9276a11-293c-459b-90d6-c33dfe3721b4"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/65db706d-3e41-48b3-a13f-eba27d4fe551.mp4"
		},
		{
			"id": "4bf37917-5ff7-4253-818a-06d9995cc65e",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Объяснение иерархии"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "c61c2ba0-e261-4aec-8520-2d93f270be66",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "dbc98f5d-8703-4ef4-9399-e829d91ddf4f",
			"type": "text",
			"properties": {
				"title": [
					[
						"При изменении состояния интерфейса или переходе между экранами важно объяснить пользователю, что случилось и куда он попал."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "ab410088-0c81-47c5-b1e6-4e3ce420b0aa",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2e3d3468-beb3-4447-af37-27b43f78c5aa",
			"type": "video",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/4b0cd487-de2f-495b-99ea-29a163c6ee2e/main_2.mp4"
					]
				]
			},
			"format": {
				"block_width": 624,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/4b0cd487-de2f-495b-99ea-29a163c6ee2e/main_2.mp4",
				"block_full_width": false,
				"block_page_width": true,
				"copied_from_pointer": {
					"id": "6cea1893-bf53-4bba-bef4-30aa944853ef",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": false
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"4b0cd487-de2f-495b-99ea-29a163c6ee2e"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/2e3d3468-beb3-4447-af37-27b43f78c5aa.mp4"
		},
		{
			"id": "755430a7-f45d-4673-bd93-b6e81f3527db",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Обучение пользователя"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3ce8a131-7083-43a1-89bd-afe7dd9d8ae0",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a2cd5d2e-e734-4cac-85b6-75cfdec256e4",
			"type": "text",
			"properties": {
				"title": [
					[
						"Обычно мы обучаем пользователей с помощью интерфейсных промо и туториалов, не привязанных к интерфейсу."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "45e048b6-95eb-4909-92c7-652f20fcda77",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7b8dc5d6-d893-439e-8057-7550f87a5c72",
			"type": "text",
			"properties": {
				"title": [
					[
						"В интерфейсных промо мы показываем элементы, с которыми пользователь может взаимодействовать. При этом важно не блокировать основное содержание."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5cc4e429-353c-43a6-8ae8-0bc3b7f740b4",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ad08bf64-2a74-4499-9dea-61d16e98096f",
			"type": "video",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/bfa52649-0043-4bdf-be1f-cd27f86d04e8/main.mp4"
					]
				]
			},
			"format": {
				"block_width": 672,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/bfa52649-0043-4bdf-be1f-cd27f86d04e8/main.mp4",
				"block_full_width": false,
				"block_page_width": true,
				"copied_from_pointer": {
					"id": "0d1a02d4-8aaa-4b49-96fa-43c368739234",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": false
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"bfa52649-0043-4bdf-be1f-cd27f86d04e8"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/ad08bf64-2a74-4499-9dea-61d16e98096f.mp4"
		},
		{
			"id": "40044b65-7e34-44a6-a826-dddedfc67143",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "f71112b4-77f1-41bf-8c3c-d2c734a1e256",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c245f145-8074-4120-9930-80e001fe41f9",
			"type": "text",
			"properties": {
				"title": [
					[
						"В туториалах мы рассказываем об обновлениях интерфейса или показываем новые функции. Используем их, когда интерфейсные промо не подходят или сложны в разработке. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1bef5650-8802-483a-946f-ea72117bb77a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1772a882-1a3e-44c0-b8fd-f327ac628048",
			"type": "video",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/89d3b5be-cb1c-4e3e-8e00-ac076f2a0f6d/res.mp4"
					]
				]
			},
			"format": {
				"block_width": 672,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/89d3b5be-cb1c-4e3e-8e00-ac076f2a0f6d/res.mp4",
				"block_full_width": false,
				"block_page_width": true,
				"copied_from_pointer": {
					"id": "83632923-ed4c-4449-ac24-3068bf5a1dba",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": false
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"89d3b5be-cb1c-4e3e-8e00-ac076f2a0f6d"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/1772a882-1a3e-44c0-b8fd-f327ac628048.mp4"
		},
		{
			"id": "d9bbd0d6-7872-44ce-9b4e-bf0599f130e4",
			"type": "header",
			"properties": {
				"title": [
					[
						"Базовые принципы"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "fa21a57f-9393-44cb-8de8-d8fa941940d1",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e3de68f7-fbab-49ba-be69-ac46a16a886d",
			"type": "text",
			"properties": {
				"title": [
					[
						"Базовые принципы одинаково работают для анимаций интерфейса и эмоциональных промоанимаций. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "28f8d11b-4e75-4f59-95bc-d21f0ce59af7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "17f91730-911c-43ab-b319-cffb64eb1a62",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Скорость"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0989a269-99fb-4dae-a6c2-122e1e8b59d7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "eed5821e-e73d-401e-90bf-aa33e67e26e6",
			"type": "text",
			"properties": {
				"title": [
					[
						"Анимация должна занимать достаточно времени, чтобы выполнить задачу и пользователь её увидел. При этом анимация не должна быть слишком долгой, чтобы не создавалось ощущение медленного интерфейса."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "7e983fa6-c719-4bae-81f1-c1332ef609f2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "85e66f9a-fbb3-474d-8462-9706a1005f85",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Обычно для анимации интерфейса подходит продолжительность 200 –500 ms. Любые анимации короче 100 ms незаметны."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5275d4a3-2fce-42eb-a01e-b89ea34db474",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bfa5997f-30a6-44c0-9c80-eeb71b7b15e2",
			"type": "text",
			"properties": {
				"title": [
					[
						"Вы можете почитать подробнее про продуктовые анимации интерфейса здесь."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0791268b-a167-4fce-8b42-3970d18b61ce",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9fb57c41-f450-42cc-8771-0330e4bfd4f1",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Зависимость от расстояния"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a573c847-0a60-4192-b753-cc2b9ea081c3",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "db789f39-1839-480b-aa5d-ece982b984fa",
			"type": "text",
			"properties": {
				"title": [
					[
						"Анимации на небольшие расстояния происходят быстрее, чем анимации, в которых объект преодолевает большое расстояние. Этот принцип работает для выбора тайминга анимаций больших или маленьких объектов."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "199a1382-31d6-402d-b636-b24b50462e5d",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "07383570-3b58-46d3-ad35-6eaa2d84bfde",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b606e0c0-56f9-4439-a25a-dc870d4c01a7/main.gif"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b606e0c0-56f9-4439-a25a-dc870d4c01a7/main.gif",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.3076923076923077,
				"copied_from_pointer": {
					"id": "13e4674c-4758-450a-bf3d-acdc43e93436",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"b606e0c0-56f9-4439-a25a-dc870d4c01a7"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/07383570-3b58-46d3-ad35-6eaa2d84bfde.gif"
		},
		{
			"id": "c20edb91-035d-4f38-92bf-4ced286c093b",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Кривые анимации"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5d5a5bb8-7488-4f45-9416-ed344445acef",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e21b7636-43e7-4d88-8998-cc66d2f44571",
			"type": "text",
			"properties": {
				"title": [
					[
						"Анимация выглядит естественно, если она работает по законам физики. Поэтому важно использовать кривые анимации."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1f091e39-9e27-4b43-a079-b3555cb67613",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3d9221c1-3a4f-49f7-9bce-a03a33408875",
			"type": "text",
			"properties": {
				"title": [
					[
						"Исключение — анимации, показывающие бесконечное движение или любой другой бесконечный процесс."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f477d02d-2c9a-4dcd-a537-9ee2c3d89720",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "49de594a-5707-4e5f-a1b2-83bb43fad7c3",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/77f0260c-d94c-4c9b-8fbd-6815ec372398/main.gif"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/77f0260c-d94c-4c9b-8fbd-6815ec372398/main.gif",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.4230769230769231,
				"copied_from_pointer": {
					"id": "42adac33-d3a4-4a17-9c25-27e9d6313102",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"77f0260c-d94c-4c9b-8fbd-6815ec372398"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/49de594a-5707-4e5f-a1b2-83bb43fad7c3.gif"
		},
		{
			"id": "3bf72109-c52c-433a-bcdc-a423c3f6e437",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "30c68c92-6f39-45ce-8a83-a1b04debe39e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "856b238f-9d1e-44b9-9917-6b4bf5c2ccc2",
			"type": "text",
			"properties": {
				"title": [
					[
						"Для продуктовых анимаций мы используем кривую с быстрым стартом анимации. Для промоанимаций рекомендуются более плавные анимации с ускорением и замедлением. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0d3a29c5-2e98-4bf0-a1e0-aee38a10491f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d4eac6b9-ac8c-4dd2-bd52-39b89ce9ced6",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/8aa5f8da-3d97-4e22-b514-502a0a74c28e/1.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/8aa5f8da-3d97-4e22-b514-502a0a74c28e/1.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5494505494505495,
				"copied_from_pointer": {
					"id": "c52bc37f-645d-4be7-a675-979edd200046",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"8aa5f8da-3d97-4e22-b514-502a0a74c28e"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/d4eac6b9-ac8c-4dd2-bd52-39b89ce9ced6.png"
		},
		{
			"id": "ba430382-6fde-48af-8bf9-a37165561709",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Основное направление"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "2b0e76ed-ee7c-4fe7-a4eb-b4a2df93df7e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ab94efa7-8dc1-48ad-8ba8-5ea69ece95c4",
			"type": "text",
			"properties": {
				"title": [
					[
						"Чтобы анимация выглядела естественно и не сбивала пользователя, у неё должно быть одно основное направление."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8be9cfb3-cf43-434c-80c2-8580b2710200",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "99c48cbd-d0e9-4bec-830f-354373366887",
			"type": "video",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/39d8fd22-800a-4476-8ae3-060f82e64651/main_1.mp4"
					]
				]
			},
			"format": {
				"block_width": 624,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/39d8fd22-800a-4476-8ae3-060f82e64651/main_1.mp4",
				"block_full_width": false,
				"block_page_width": true,
				"copied_from_pointer": {
					"id": "fc5e8118-2ed5-46c5-ac42-d57b9dc1c6a1",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": false
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"39d8fd22-800a-4476-8ae3-060f82e64651"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/99c48cbd-d0e9-4bec-830f-354373366887.mp4"
		},
		{
			"id": "7a88d48e-5888-488d-a69e-f8910b8b81a1",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "97b73129-1f20-4006-9b1e-ad8efef703a2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ecbc137f-5799-47f5-8279-3ec38e745bda",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Мы не рекомендуем анимировать объекты в нескольких различных направлениях, такие анимации тяжело воспринимать. "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "321518b2-eaaf-44da-a854-5e1afeca84d7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6e6b2571-e5bb-4a3a-82fd-465f650ac471",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Движение по дугам"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d36077a1-ccf9-4144-936b-76fe87638a7a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "94332ab1-60db-428b-ade2-a14c256f2507",
			"type": "text",
			"properties": {
				"title": [
					[
						"Если объект перемещается по диагонали, рекомендуем анимировать его по дуге."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b8b68d2a-bdf8-4e8f-9cf8-d977183c38a8",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ff9c4b0f-b694-4cba-b64b-cc45339a030a",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a61ed94c-b214-49e9-8ae9-8893852d4ca6/comp1.gif"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a61ed94c-b214-49e9-8ae9-8893852d4ca6/comp1.gif",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.55,
				"copied_from_pointer": {
					"id": "c4ef567f-f9d0-4516-b69f-4d48d9c0b212",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"a61ed94c-b214-49e9-8ae9-8893852d4ca6"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/ff9c4b0f-b694-4cba-b64b-cc45339a030a.gif"
		},
		{
			"id": "50de8974-41f5-4e7e-a8e1-3b8047f75ba4",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "776ccdfa-abaf-441a-9b67-a382ff8d333f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5c9741a6-cd34-4ec2-8e82-1f74cf509fae",
			"type": "text",
			"properties": {
				"title": [
					[
						"Однако если анимация перемещения сопровождается заметным изменением масштаба, от этого принципа стоит отказаться."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b89e76b7-8428-40fe-9c96-c7289de8268a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "32acf4a1-9593-4c81-8ed5-a30e802ab2f3",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/7b4eb07f-9d66-4fc6-ad87-ec26af013775/comp2.gif"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/7b4eb07f-9d66-4fc6-ad87-ec26af013775/comp2.gif",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.55,
				"copied_from_pointer": {
					"id": "4bab7e24-72f7-4444-a0b1-e6168d1bd804",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"7b4eb07f-9d66-4fc6-ad87-ec26af013775"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/32acf4a1-9593-4c81-8ed5-a30e802ab2f3.gif"
		},
		{
			"id": "97b2e2cb-8638-4d67-bfe8-101c8b86c35c",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Сжатие и растяжение",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e38a96be-6666-4e56-a179-e3ef191bb4ec",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f259af99-39d0-4dc9-a720-c8a8a6254cb5",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/892ae00d-f115-4f99-866c-b74787f86fea/16-boll.gif"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/892ae00d-f115-4f99-866c-b74787f86fea/16-boll.gif",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.275,
				"copied_from_pointer": {
					"id": "8102f0c8-2a7a-49c3-ae9f-ca318f2d5c18",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"892ae00d-f115-4f99-866c-b74787f86fea"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/f259af99-39d0-4dc9-a720-c8a8a6254cb5.gif"
		},
		{
			"id": "f1858551-ebc4-4d66-999a-446ccdf09aca",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Мы не рекомендуем использовать сжатие и растяжение движущихся объектов в интерфейсных анимациях."
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "0c98fc9c-2dcf-4c56-86c0-0b6b2f7115c1",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "765d410d-b04b-4c31-ae79-294535b6ba1a",
			"type": "text",
			"properties": {
				"title": [
					[
						"В промоанимациях этот приём применяется на усмотрение дизайнера."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b7c5297e-5962-4313-b374-966c8c3d2b65",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d4f9c59a-31c4-4780-9d52-4b5fa59f082f",
			"type": "header",
			"properties": {
				"title": [
					[
						"Ощущения"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5db8e6e7-729e-4644-907e-5889bbc941f4",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "36593fa5-d28f-4c2f-8167-c9173cc11712",
			"type": "text",
			"properties": {
				"title": [
					[
						"Помимо решения задачи продукта, важно, чтобы анимация создавала правильное ощущение. Здесь мы разделим анимации на две большие категории:"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "357a93c0-151f-4a4e-b331-bec536cfda8f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5bdf0fd7-9471-4d47-99d5-7046a90534e9",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"продуктовые,"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5e4b5421-7c1e-42c4-beca-2cc25c133fe2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "56320cca-8dfb-4dcb-8e5d-ad755313ccbe",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"эмоциональные."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e4718e7d-8189-4585-8357-3ee0fae1f708",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b5c068ca-ab00-4f85-81b5-852ee5b16412",
			"type": "header",
			"properties": {
				"title": [
					[
						"Продуктовые анимации"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e1686af6-e6d1-4626-a114-dff214359853",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cc5e04fc-49ad-42f9-b2f0-309bfdefafc8",
			"type": "text",
			"properties": {
				"title": [
					[
						"К продуктовым анимациям относятся анимации продуктивити-инструментов, но эти рекомендации подойдут и для других продуктов, которые создают те же эмоции."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "335c54c0-a6f9-4420-807d-ab4a13efcc17",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "473262a3-8620-45ce-a0f7-83b5d1207b9e",
			"type": "text",
			"properties": {
				"title": [
					[
						"Через ощущения мы транслируем характеристики сервисов:"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b6682322-b09b-40fc-b44a-095bd9b800b3",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0f75ba3d-1ec8-4f2b-9be1-84852460671b",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"технологичность,"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "c90ec403-d66c-49a4-8b62-5b5dce4b4132",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "af9f153b-4718-44ea-aaef-6ddf7465dd58",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"быстрота,"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "6e02ff20-69db-4f4b-9360-8498339ab29d",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a75f600e-71d9-4fa8-bb5c-042dec9f8596",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"современность."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "4acb1b26-5442-4bd0-800a-017b37b1ef0f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5ec55e84-611e-49ef-b7dd-7c7c8a921675",
			"type": "text",
			"properties": {
				"title": [
					[
						"Современный и технологичный продукт быстро реагирует на действия пользователя и не нагружает его лишними визуальными эффектами, особенно на часто повторяющихся действиях."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a1449ef0-8016-4d1b-a7a4-ce04ebd35303",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "431140f6-55dd-45a5-85b9-ad9a597a460e",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Быстрые изменения"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "dea9462e-3b81-4b70-b2bd-7ac4d4ea5a45",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4bc66b77-a717-4a7c-8d3e-f61271020c53",
			"type": "text",
			"properties": {
				"title": [
					[
						"Важно создать ощущение быстрого продукта, который даёт молниеносный фидбэк на действие, когда это возможно. Самая быстрая анимация — это отсутствие анимации, что делает интерфейс менее понятным и современным. Мы решаем эту задачу быстрыми изменениями."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0269a6ae-03b8-4622-a938-4785f38aadae",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7cda7cea-45eb-4121-87ea-70ffcbca4f69",
			"type": "text",
			"properties": {
				"title": [
					[
						"Интерфейс быстро показывает фидбэк на действие пользователя. После того как показана основная заметная часть анимации, анимация может продолжаться."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "99e0326a-db18-486f-987b-d4f52292060a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6dee9413-b646-4268-a6f1-836a8dee18e6",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/ac8c951c-c030-40c6-a9cd-42fa451b435e/timeline.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/ac8c951c-c030-40c6-a9cd-42fa451b435e/timeline.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.4258241758241758,
				"copied_from_pointer": {
					"id": "8044fbe2-47f7-4cfa-b486-c95c45a5eb34",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"ac8c951c-c030-40c6-a9cd-42fa451b435e"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/6dee9413-b646-4268-a6f1-836a8dee18e6.png"
		},
		{
			"id": "dc1e8088-4784-46bd-91d8-db9ba0b46fff",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "adf80ac8-7091-40df-826b-8ccda85a7d65",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fa87742d-6087-42bb-84f1-fc359a187294",
			"type": "text",
			"properties": {
				"title": [
					[
						"Например, пользователь нажимает на чекбокс, фон перекрашивается без анимации, а затем появляется анимация галки."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "9c71bd9b-8871-4b19-90d4-151191ad9e55",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e60e48eb-b09b-4a8b-b9b0-77df41871ed0",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a067fcfa-9a7d-42d7-9a60-97b61551a0fd/18-check.gif"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a067fcfa-9a7d-42d7-9a60-97b61551a0fd/18-check.gif",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.275,
				"copied_from_pointer": {
					"id": "dccd7ea4-ca1b-4446-8192-96da30c6b86f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"a067fcfa-9a7d-42d7-9a60-97b61551a0fd"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/e60e48eb-b09b-4a8b-b9b0-77df41871ed0.gif"
		},
		{
			"id": "ecde79fa-f8c8-48e4-afe8-43882bbd17c6",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "33d0ad76-71e7-448b-8e85-f297bac74128",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a87c750d-a0d8-4ae1-bb4a-d826bbdb3d5c",
			"type": "text",
			"properties": {
				"title": [
					[
						"Поэтому мы делаем ховеры в веб-версиях продуктивити инструментов без анимации."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "78c36abb-a724-41ee-94c1-d7c76353842f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3d6a0bfb-278a-4b30-9bb5-845999a19f41",
			"type": "video",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/6ba14b6f-ef7d-4931-a861-4efd069564af/main.mp4"
					]
				]
			},
			"format": {
				"block_width": 624,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/6ba14b6f-ef7d-4931-a861-4efd069564af/main.mp4",
				"block_full_width": false,
				"block_page_width": true,
				"copied_from_pointer": {
					"id": "c2eebefd-f460-4b30-be93-65826903a04b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": false
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"6ba14b6f-ef7d-4931-a861-4efd069564af"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/3d6a0bfb-278a-4b30-9bb5-845999a19f41.mp4"
		},
		{
			"id": "abb63b77-b634-4fff-8041-e600e8ff0c27",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "dfb6f2e8-448f-4361-8a15-164623429b70",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5706acae-d769-494a-85bd-085dedafc769",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Обычно полная анимация поисдходит за 200 – 500 ms в зависимости от размера."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "ec377bba-d466-40f0-bea9-317853a588ca",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "be1c6c9a-e3e3-416b-bfe1-45d754e36513",
			"type": "video",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/2902cf50-21d1-4106-8b31-83777c9ce0ca/main.mp4"
					]
				]
			},
			"format": {
				"block_width": 624,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/2902cf50-21d1-4106-8b31-83777c9ce0ca/main.mp4",
				"block_full_width": false,
				"block_page_width": true,
				"copied_from_pointer": {
					"id": "6991d0bd-c2e2-426d-96d3-8860a77febba",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": false
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"2902cf50-21d1-4106-8b31-83777c9ce0ca"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/be1c6c9a-e3e3-416b-bfe1-45d754e36513.mp4"
		},
		{
			"id": "16dc49fb-fda7-42d3-95a7-4a09b9cdfd75",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Быстрое скрытие"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a1f520f9-3aa5-4e0b-9c73-e06a4935141d",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7776dcea-80be-47f1-9916-bdd2010de9a7",
			"type": "text",
			"properties": {
				"title": [
					[
						"Когда нужно показать какой-то объект, используется анимация средней продолжительности. При этом скрытие объекта происходит быстро или без анимации."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "408bfd80-7d07-4c7c-8fef-145385c39e9b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2bd03e65-19c2-472b-9dab-45a87e89b87b",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/7f8862e0-50d4-4422-ad06-f3e0922af0dc/comp21.gif"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/7f8862e0-50d4-4422-ad06-f3e0922af0dc/comp21.gif",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.4225,
				"copied_from_pointer": {
					"id": "0ecdaf32-e677-4258-ac9f-948bc518457f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"7f8862e0-50d4-4422-ad06-f3e0922af0dc"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/2bd03e65-19c2-472b-9dab-45a87e89b87b.gif"
		},
		{
			"id": "44ca9810-59a7-49a2-8f0a-a1ff51b810ac",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "ce80c01d-49e8-4ceb-93d2-7521967dec70",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "10041b9d-1105-4d27-bf29-945afd3aaac6",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Кривые анимации"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "34751f6f-a93c-4b53-9f00-76bc93fefbb8",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "10d234bc-f4d7-4a51-aa39-48eb48ddf6c6",
			"type": "text",
			"properties": {
				"title": [
					[
						"Когда анимацию вызывает действие пользователя, следует использовать "
					],
					[
						"easy-out ",
						[
							[
								"b"
							]
						]
					],
					[
						"анимации, чтобы усилить ощущение от скорости взаимодействия."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5112d406-efba-40a6-83b2-cd91105c8904",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c4f31633-8e5b-400d-97b9-600bfc4176db",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/cce3c3b5-69cd-4fd6-918d-8b55a0214f04/23-ease.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/cce3c3b5-69cd-4fd6-918d-8b55a0214f04/23-ease.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5494505494505495,
				"copied_from_pointer": {
					"id": "c5eb2ac1-3287-4b5c-9313-a3a2ec477b70",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"cce3c3b5-69cd-4fd6-918d-8b55a0214f04"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/c4f31633-8e5b-400d-97b9-600bfc4176db.png"
		},
		{
			"id": "02df4192-bdff-444b-9543-69dcc30be3b8",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "0b30ec09-f5a5-4fad-8022-ee8bb3111901",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0f6b011f-add7-472c-ba5c-56a3b6ee356f",
			"type": "text",
			"properties": {
				"title": [
					[
						"Эти анимации не подходят, когда анимация вопроизводится независимо от действий пользователя. В этом случае мы используем "
					],
					[
						"easy-in-out",
						[
							[
								"b"
							]
						]
					],
					[
						" анимацию."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f9af1f46-984b-4d92-888c-3a4934d130d9",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2aa96f2c-ed57-4ef9-ad94-29f6eac6efa1",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Уместность"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "544b370f-1c2e-4f00-9c33-8a10b63a9d28",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "498b80ee-29bf-4f5c-a1bf-fb993170f5b8",
			"type": "text",
			"properties": {
				"title": [
					[
						"Не рекомендуется использовать акцентные анимации на часто повторяющихся действих. Например, не стоит использовать баунс-эффект на выделении элементов: это может раздражать пользователей, которые выделяют много элементов за раз. Чем чаще повторяется действие, тем проще должна быть анимация."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "082d9dcd-af50-4b28-95f4-69fd09865e25",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "959484b9-20f8-4e0a-b58e-f0a6df6e7e2b",
			"type": "video",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a9210ec5-cfce-42dc-b70e-f0a4d1234c5c/main_1.mp4"
					]
				]
			},
			"format": {
				"block_width": 624,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a9210ec5-cfce-42dc-b70e-f0a4d1234c5c/main_1.mp4",
				"block_full_width": false,
				"block_page_width": true,
				"copied_from_pointer": {
					"id": "5f8b768d-e988-4516-a2ea-b85dd6d41964",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": false
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"a9210ec5-cfce-42dc-b70e-f0a4d1234c5c"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/959484b9-20f8-4e0a-b58e-f0a6df6e7e2b.mp4"
		},
		{
			"id": "5f5d2e91-3fc1-45b7-baeb-c8c048957503",
			"type": "header",
			"properties": {
				"title": [
					[
						"Эмоциональные анимации"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a9a5fdcb-f5a5-4cdf-9990-24e4c17fbf18",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2021ec11-aa3a-4dce-8e1d-c3be03bbb5bf",
			"type": "text",
			"properties": {
				"title": [
					[
						"Интерфейсные промо (туториалы, анимированные иллюстрации и так далее) и анимации в развлекательных продуктах решают абсолютно другие задачи, и поэтому должны создавать другие ощущения. Через эмоциональные анимации мы транслируем характеристики продуктов:"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "259e0bf4-54cb-42c1-b1d6-e005824b0960",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2b1930a1-8466-459c-aed9-7419e87cc7ef",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"человечность,"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "c051f08e-a782-473f-b51a-24552d9310e5",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f776aaed-5f16-462a-8346-37c4c9a50d59",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"современность."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "2a6f032b-2bfe-40bf-bc01-b7b92f60d8db",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ab3eeaa6-1d58-449d-8f70-6a27f746e4d5",
			"type": "text",
			"properties": {
				"title": [
					[
						"Такие анимации должны быть мягче и могут занимать чуть больше времени."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "959ed6e7-1c9c-4326-b5cf-718cf38a066e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "959970cd-852e-40e6-aabb-4a63f4a200f4",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Скорость"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "793be313-817f-40b1-bdf5-821de34d956b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "93f8b320-b1ca-4c5b-b239-647e4dc53e35",
			"type": "text",
			"properties": {
				"title": [
					[
						"Если главная задача продуктовой анимации — показать изменение состояния как можно быстрее и понятнее, то в эмоциональных анимациях мы ищем компромисс между эффектностью и скоростью."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "ae22a644-a99c-4930-99fb-e334e99a8cf3",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7d829e6b-03da-4281-9ea2-e60bee3d6612",
			"type": "video",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/24d6be30-f57c-446b-b2f7-6c1df201a307/main_2.mp4"
					]
				]
			},
			"format": {
				"block_width": 624,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/24d6be30-f57c-446b-b2f7-6c1df201a307/main_2.mp4",
				"block_full_width": false,
				"block_page_width": true,
				"copied_from_pointer": {
					"id": "dcaee7d8-de97-45bf-a06e-2b884c469fff",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": false
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"24d6be30-f57c-446b-b2f7-6c1df201a307"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/7d829e6b-03da-4281-9ea2-e60bee3d6612.mp4"
		},
		{
			"id": "3640bc3b-cc4a-4d24-b161-364cb605cac3",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "f1187119-8fa0-4918-b778-9bb74a30a577",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "11d15091-54fd-410a-9580-4d6a85cd8d0a",
			"type": "text",
			"properties": {
				"title": [
					[
						"Важно, чтобы анимации не блокировали действия пользователя, поэтому анимации, которые блокируют интерфейс не длятся больше 200ms."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "fe2ee44a-93ee-46a1-9751-64e92f0fa7a2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "635e1327-92fa-4a3f-b5bb-1fe0eaaf33f4",
			"type": "column_list",
			"content": [
				"9a853b48-d72a-47d1-8b28-7079db08cabf",
				"44ef907b-c878-4167-b82f-d51cacc8f084"
			],
			"format": {
				"copied_from_pointer": {
					"id": "ef00e91b-5e2c-487f-80e1-7fe666f47d20",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "521a86af-a746-49f5-91eb-a22548f51225",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Кривые анимации"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e901b9e7-83fc-40bd-a206-9dc69cc072d8",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "46f1130b-b880-40a7-a916-115ed4a98d28",
			"type": "text",
			"properties": {
				"title": [
					[
						"Мы рекомендуем использовать базовую кривую анимации, которая подходит для большинства ситуаций."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5aadee1d-82a6-4b1e-ba12-f0de8b9b7f59",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9f1c5df7-7f6e-4d0c-9f6c-0d3685b70622",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/48daa8c1-6dd3-4c05-85e2-3f9e81b40778/main.gif"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/48daa8c1-6dd3-4c05-85e2-3f9e81b40778/main.gif",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5494505494505495,
				"copied_from_pointer": {
					"id": "b2b8472b-2bb3-4420-be36-6658c4c6287e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"48daa8c1-6dd3-4c05-85e2-3f9e81b40778"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/9f1c5df7-7f6e-4d0c-9f6c-0d3685b70622.gif"
		},
		{
			"id": "3237c494-50bd-45e1-b0c9-d18166a76522",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "94e8ea64-7a4b-44a0-b942-2dff77af3548",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "77839ceb-b770-4d96-b22c-aceac4af56e6",
			"type": "text",
			"properties": {
				"title": [
					[
						"Однако если нужно создать другое ощущение, допустимо изменять кривые, в том числе использовать "
					],
					[
						"easy-in",
						[
							[
								"b"
							]
						]
					],
					[
						" и "
					],
					[
						"easy-out",
						[
							[
								"b"
							]
						]
					],
					[
						"."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5b6d3a45-831b-4b23-98fa-e4484242a976",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4e18e4b2-047f-48ad-9d43-f8e27250b510",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b61739c0-44f0-4436-9da3-e05a75808ecc/main.gif"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b61739c0-44f0-4436-9da3-e05a75808ecc/main.gif",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5494505494505495,
				"copied_from_pointer": {
					"id": "125c8c6f-5de3-4fbe-b57a-6fb4d456547e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"b61739c0-44f0-4436-9da3-e05a75808ecc"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/4e18e4b2-047f-48ad-9d43-f8e27250b510.gif"
		},
		{
			"id": "e654da12-5cdb-48ba-8207-2f67c1f99e24",
			"type": "header",
			"properties": {
				"title": [
					[
						"Рекомендации по разработке анимаций"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "fb6909c5-16a8-4ec2-9463-d35c7c369eb4",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ae9026cb-4738-427a-95ef-32a44dd65f39",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Инструменты"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "2f841707-9926-4cd0-b1aa-5aa1a62545f8",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9327abbe-3b6a-4617-a56b-6c2a7c10533e",
			"type": "text",
			"properties": {
				"title": [
					[
						"Дизайнеры могут использовать любой инструмент для создания анимаций. Однако в разработке интерфейсных анимаций мы делаем фокус на создание интерактивных прототипов, которые можно протестировать хотя бы на себе."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "47e520f0-dc83-467a-b915-6e080ca191ef",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b93d5497-0e22-4919-97ec-d4db61c7277d",
			"type": "text",
			"properties": {
				"title": [
					[
						"After Effects",
						[
							[
								"b"
							]
						]
					],
					[
						" подходит для создания анимаций без интерактива — когда пользователь не влияет на появление анимации. Например, для промоанимаций. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "01106810-85ac-43cf-986a-1be7e7937b23",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "42a9f433-cfdb-4742-a14c-30bbcb013b04",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/41c64ccf-5328-47b4-9147-9f98d422b232/33-ae.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/41c64ccf-5328-47b4-9147-9f98d422b232/33-ae.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5494505494505495,
				"copied_from_pointer": {
					"id": "d3d4ab07-19d0-4dc8-9432-0589dfe95b27",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"41c64ccf-5328-47b4-9147-9f98d422b232"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/42a9f433-cfdb-4742-a14c-30bbcb013b04.png"
		},
		{
			"id": "359523b4-3960-43d5-9ccc-8f2bd0d75f82",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "583fddeb-472e-446b-b169-c5da2d1c56aa",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7630b6d8-8f5d-4dde-921f-be11d8f10f37",
			"type": "text",
			"properties": {
				"title": [
					[
						"Principle",
						[
							[
								"b"
							]
						]
					],
					[
						" или "
					],
					[
						"Framer",
						[
							[
								"b"
							]
						]
					],
					[
						" подходят для интерактивных прототипов. Часто анимация, которая эффектно выглядит на ролике, оказывается неудачной в продукте. Такие анимации бывают слишком затянутыми или работают не так, как планировалось. Чем ближе логика прототипа к продукту, тем больше ошибок можно исправить на этапе дизайна."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "371548ac-7f6a-49bf-9b62-19b4ad6257eb",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e6f212a6-0a8d-49f9-95c2-b4bd9da5ad63",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/9af4026f-b0b7-4d33-bef3-8c10da043ff1/34-framer.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/9af4026f-b0b7-4d33-bef3-8c10da043ff1/34-framer.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5659340659340659,
				"copied_from_pointer": {
					"id": "8bbc487b-2b77-4b71-9a53-71bb49c2d0d1",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"file_ids": [
				"9af4026f-b0b7-4d33-bef3-8c10da043ff1"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/e6f212a6-0a8d-49f9-95c2-b4bd9da5ad63.png"
		},
		{
			"id": "fb6875e3-899a-4d44-ae85-aef12f2554f6",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "52336b1b-d561-422d-9f5e-73161883e8c2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f5097b73-1152-4e95-8919-54eed014af82",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9a853b48-d72a-47d1-8b28-7079db08cabf",
			"type": "column",
			"content": [
				"bd3c5aa4-c20d-43e3-98d7-73c3105064ec",
				"923c7394-f796-452f-9ba5-72be68569841"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "2d8e3491-eb68-458d-9fe5-7ce8981d9c6f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "635e1327-92fa-4a3f-b5bb-1fe0eaaf33f4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "44ef907b-c878-4167-b82f-d51cacc8f084",
			"type": "column",
			"content": [
				"e24313c5-d0a0-434f-ba5c-ecd6304ef256",
				"e144cab9-228d-49fd-84a3-1d116a8b0234"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "8f9dca17-3699-4019-85ef-cc8c9f1c2af5",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "635e1327-92fa-4a3f-b5bb-1fe0eaaf33f4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bd3c5aa4-c20d-43e3-98d7-73c3105064ec",
			"type": "video",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/2ca72eca-fd1e-48dc-9619-42b06ea4cf66/normal.mp4"
					]
				]
			},
			"format": {
				"block_width": 400,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/2ca72eca-fd1e-48dc-9619-42b06ea4cf66/normal.mp4",
				"block_full_width": false,
				"block_page_width": false,
				"copied_from_pointer": {
					"id": "f8a621ca-8956-4176-b430-e0eb1cfc6603",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": false
			},
			"parent_id": "9a853b48-d72a-47d1-8b28-7079db08cabf",
			"parent_table": "block",
			"file_ids": [
				"2ca72eca-fd1e-48dc-9619-42b06ea4cf66"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/bd3c5aa4-c20d-43e3-98d7-73c3105064ec.mp4"
		},
		{
			"id": "923c7394-f796-452f-9ba5-72be68569841",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Приятная анимация"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "8ceabb08-5a24-4cdb-900b-0b42803107eb",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a853b48-d72a-47d1-8b28-7079db08cabf",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e24313c5-d0a0-434f-ba5c-ecd6304ef256",
			"type": "video",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/1b8a819d-552b-41d9-846e-9a7b0b11e0a9/slow.mp4"
					]
				]
			},
			"format": {
				"block_width": 400,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/1b8a819d-552b-41d9-846e-9a7b0b11e0a9/slow.mp4",
				"block_full_width": false,
				"block_page_width": false,
				"copied_from_pointer": {
					"id": "121b077e-8a0f-4276-90bd-0837c26e1d5b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": false
			},
			"parent_id": "44ef907b-c878-4167-b82f-d51cacc8f084",
			"parent_table": "block",
			"file_ids": [
				"1b8a819d-552b-41d9-846e-9a7b0b11e0a9"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/e24313c5-d0a0-434f-ba5c-ecd6304ef256.mp4"
		},
		{
			"id": "e144cab9-228d-49fd-84a3-1d116a8b0234",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Анимация не успевает воспроизвестись"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "4d6588a5-80df-4fa1-b6d4-a809acacb385",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "44ef907b-c878-4167-b82f-d51cacc8f084",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		}
	],
	"headers": [
		{
			"title": "Задачи",
			"id": "d581e6ff-3d59-4aaf-ba09-f9be66e377ed"
		},
		{
			"title": "Базовые принципы",
			"id": "d9bbd0d6-7872-44ce-9b4e-bf0599f130e4"
		},
		{
			"title": "Ощущения",
			"id": "d4f9c59a-31c4-4780-9d52-4b5fa59f082f"
		},
		{
			"title": "Продуктовые анимации",
			"id": "b5c068ca-ab00-4f85-81b5-852ee5b16412"
		},
		{
			"title": "Эмоциональные анимации",
			"id": "5f5d2e91-3fc1-45b7-baeb-c8c048957503"
		},
		{
			"title": "Рекомендации по разработке анимаций",
			"id": "e654da12-5cdb-48ba-8207-2f67c1f99e24"
		}
	]
}} />
);

export default NotionAnimation;
